export default __webpack_public_path__ + "static/media/view4_year_province_place_.8724cb83.csv";